import { VINRecord } from '@web/vin-sessions/types';

export function buildVinSessionEventProperties(vinRecord: VINRecord) {
    return {
        model: vinRecord.model,
        model_year: vinRecord.modelYear,
        model_number: vinRecord.modelNumber,
    };
}

export function calculateDurationInMilliseconds(startedAt: number | null): number | undefined {
    if (startedAt === null) {
        return undefined;
    }
    return Math.round(Date.now() - startedAt);
}
